<script setup>
import { ref, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});

const hasError = ref(false);
const showGallery = ref(false);
const thumbFailed = ref(false);

const { filteredCurrentChatAttachments } = useMessageContext();

const imageSrc = computed(() => {
  if (thumbFailed.value) {
    return props.attachment.dataUrl;
  }
  return props.attachment.thumbUrl || props.attachment.dataUrl;
});

const handleError = () => {
  if (
    !thumbFailed.value &&
    props.attachment.thumbUrl &&
    props.attachment.dataUrl
  ) {
    thumbFailed.value = true;
  } else {
    hasError.value = true;
  }
};
</script>

<template>
  <div
    class="overflow-hidden contain-content rounded-xl cursor-pointer"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col items-center justify-center gap-1 text-xs text-center rounded-lg size-full bg-n-alpha-1 text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <img
      v-else
      class="skip-context-menu max-w-80"
      :src="imageSrc"
      :width="attachment.width"
      :height="attachment.height"
      @error="handleError"
    />
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
